/* global document */
import * as R from 'ramda';


let _$q;
let _smoothScroll;
let _vmSharedModelService;

export default class VendorManagementNavigationService {
  constructor(
    $q,
    smoothScroll,
    vmSharedModelService
  ) {
    _$q = $q;
    _smoothScroll = smoothScroll;
    _vmSharedModelService = vmSharedModelService;
  }

  scrollToVendor(vendorId) {
    const dfdScroll = _$q.defer();
    const vendorElement = document.getElementById(`vendor-${vendorId}`);
    const scrollOptions = {
      duration: 1000,
      offset: 60,
      callbackAfter: dfdScroll.resolve,
    };
    _smoothScroll(vendorElement, scrollOptions);

    return dfdScroll.promise;
  }

  expandVendor(vendorId) {
    R.find(
      R.propEq(
        'vendorId',
        vendorId
      ),
      _vmSharedModelService.vendors
    ).isExpanded = true;
  }

  scrollToProduct(productId) {
    const dfdScroll = _$q.defer();
    const productElement = document.getElementById(`product-${productId}`);
    const scrollOptions = {
      duration: 1000,
      offset: 60,
      callbackAfter: dfdScroll.resolve,
    };
    _smoothScroll(productElement, scrollOptions);

    return dfdScroll.promise;
  }

  expandProduct(vendorId, productId) {
    R.find(
      R.propEq(
        'productId',
        productId
      ),
      R.find(
        R.propEq(
          'vendorId',
          vendorId
        ),
        _vmSharedModelService.vendors
      ).products
    ).isExpanded = true;
  }
}

VendorManagementNavigationService.$inject = [
  '$q',
  'smoothScroll',
  'vmSharedModelService'
];
